import React, { useState } from 'react';
import './TabbedLayout.scss';

const TabbedLayout = ({ tabs, children }) => {
    const [activeTab, setActiveTab] = useState(tabs[0].id);

    return (
        <div className="tabbed-layout">
            <div className="tabbed-layout__sidebar">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`tabbed-layout__tab ${activeTab === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                        aria-selected={activeTab === tab.id}
                        role="tab"
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div className="tabbed-layout__content">
                {children(activeTab)}
            </div>
        </div>
    );
};

export default TabbedLayout; 